import {
  CardDataInter,
  CustomProps,
  generateCustomProps
} from '../../../common.type'
import { GameFavorites } from '@/views/game/classes'
import { LandscapeProps } from '.'
import { PlatformCategories } from '@/api/game/type'
import {
  PlatformCategoriesItem,
  PlatformCategoriesItemInter
} from '@/service/game/entity/gameCategorie'
import { gameOpener } from '@/views/game/services'
import AnchorHot, { AnchorHotInter } from '@/service/game/entity/anchorHot'
import GameItem, { GameItemInter } from '@/service/game/entity/gameItem'

/** 转换Props类型声明 */
export interface GetProps<T extends CardDataInter = CardDataInter> {
  <Data extends T = T>(
    data: Data,
    custom?: CustomProps<Data, LandscapeProps>
  ): LandscapeProps
}

/** 方型卡片 获得props */
export const getProps: GetProps = (data, custom) => {
  if (PlatformCategoriesItem.isThisType(data)) {
    return getPropsByPlatformCategoriesItem(data, custom)
  } else if (GameItem.isThisType(data)) {
    return getPropsByGameItem(data, custom)
  } else if (AnchorHot.isThisType(data)) {
    return getPropsByAnchorHot(data, custom)
  } else {
    return getPropsByPlatformCategories(
      data as PlatformCategories,
      custom as CustomProps<PlatformCategories, LandscapeProps>
    )
  }
}

/** 根据游戏项 */
// eslint-disable-next-line  @typescript-eslint/no-unused-vars
const getPropsByGameItem: GetProps<GameItemInter> = (data, custom?) => {
  throw new Error('并未扩展【GameItem】的样式渲染!')
}

/** 根据主播游戏项 */
// eslint-disable-next-line  @typescript-eslint/no-unused-vars
const getPropsByAnchorHot: GetProps<AnchorHotInter> = (data, custom?) => {
  throw new Error('并未扩展【AnchorHot】的样式渲染!')
}

/** 根据平台类型生成配置项 */
const getPropsByPlatformCategoriesItem: GetProps<
  PlatformCategoriesItemInter
> = (data, custom?) => {
  /** props */
  const props: LandscapeProps = {
    imgUrl: data.platformIcon,
    // 标记日期2024年5月12号 旧版的仍然走旧逻辑,新版的,才直接显示完整的整图 自定义图片,则显示成一张整图的样式,非自定义图片,则显示成右侧局部的图片
    isCompleteImage: data.isCustomIcon,
    gameName: data.brand,
    logoUrl: data.platformLogo,
    description: data.slogan,
    categoryId: data.gameCategoryId,
    isMaintain: data.maintainStatus,
    isShowFavorited: false,
    handleClickCard: () => gameOpener.openGame(data),
    handleClickFavorIcon: () => GameFavorites.collectGame(data)
  }
  // 自定义放在最后,覆盖前面的
  const customProps = generateCustomProps(data, props, custom)
  return Object.assign(props, customProps)
}

/** 旧版的数据结构 */
const getPropsByPlatformCategories: GetProps<PlatformCategories> = (
  data,
  custom?
) => {
  /** 生成图片相关 */
  const generateImgRelation = () => {
    const ret = {} as Pick<LandscapeProps, 'imgUrl' | 'isCompleteImage'>
    const { gameIconLarge, largeIcon, gameIcon } = data
    // 如果是用户自定义整图,则直接返回用户自定义图
    if (Boolean(data.customLargeIcon)) {
      ret.imgUrl = largeIcon || gameIconLarge
      ret.isCompleteImage = true
    }
    // 暂时注释掉横向卡片后台合图功能,后台可能还未完成该功能
    // 如果是后台形成的合同,则直接返回后台返回的合图,优先级低于用户自定义图
    // else if (Boolean(data.isCompositePictureHot)) {
    //   ret.imgUrl = data.compositePictureHotIcon
    //   ret.isCompleteImage = true
    // }
    // 不是整张合图;
    else {
      ret.imgUrl = gameIconLarge || largeIcon || gameIcon
      ret.isCompleteImage = false
    }
    return ret
  }
  // 图片相关字段
  const { imgUrl, isCompleteImage } = generateImgRelation()

  /** props */
  const props: LandscapeProps = {
    imgUrl,
    isCompleteImage: isCompleteImage,
    gameName: data.brand || data.gameName,
    logoUrl: data.logo,
    description: data.slogan,
    status: data.recommendStatus ? 'remenber' : undefined,
    categoryId: data.gameCategoryId,
    isMaintain: data.maintainStatus,
    isShowFavorited: false,
    handleClickCard: () => gameOpener.openGame(data),
    handleClickFavorIcon: () => GameFavorites.collectGame(data)
  }
  // 自定义放在最后,覆盖前面的
  const customProps = generateCustomProps(data, props, custom)
  return Object.assign(props, customProps)
}
